module.exports = __webpack_public_path__ + "static/energy_20-bafe4a9ffe64115f33ee610ac17fb1fa.jpg";